export default "__VITE_PUBLIC_ASSET__968937bd__"